/* eslint-disable */
import { useState, useEffect } from "react";


const useIsDark = () => {
    const getIsDark = () => document.documentElement.classList.contains("dark")
    const [isDark, setIsDark] = useState(getIsDark)

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setIsDark(getIsDark())
        })

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["class"]
        })

        return () => observer.disconnect()
    }, [])

    return isDark
}
export default useIsDark